<script>
	import options from './ErrorGlobalModal.options'
	export default options
</script>

<template>
	<div class="nlx-error-global-modal__backdrop" v-if="modalVisibiltyState">
		<article class="nlx-error-global-modal">
			<button @click="closeModal" class="nlx-error-global-modal__close-button">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2" stroke="#000" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
			</button>
			<h1 class="nlx-error-global-modal__title">{{title}}</h1>
			<div class="nlx-error-global-modal__button-container">
				<button class="nlx-button" @click="reloadPage">{{buttonLabel}}</button>
			</div>
		</article>
	</div>
</template>
